import PubSub from 'underpub-js';
import slick from 'slick-carousel';

var Timeline = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-Timeline',
  };

  $.extend(true, this.options, options);
};

Timeline.prototype.init = function() {
  const self = this;

  self.$navigationSlides = self.options.$el.find(
    `.${self.data.baseClass}__navigation__slides`,
  );
  self.$prevArrow = self.options.$el.find(
    `.${self.data.baseClass}__navigation__arrow--prev`,
  );
  self.$nextArrow = self.options.$el.find(
    `.${self.data.baseClass}__navigation__arrow--next`,
  );
  self.$contentSlides = self.options.$el.find(
    `.${self.data.baseClass}__content__slides`,
  );

  self.initNavigationSlider();
  self.initContentSlider();
};

Timeline.prototype.initNavigationSlider = function() {
  const self = this;

  self.$navigationSlides.slick({
    slidesToScroll: 1,
    slidesToShow: 5,
    prevArrow: self.$prevArrow,
    nextArrow: self.$nextArrow,
    infinite: false,
    centerMode: true,
    centerPadding: 0,
    focusOnSelect: true,
    asNavFor: self.$contentSlides,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
};

Timeline.prototype.initContentSlider = function() {
  const self = this;

  self.$contentSlides.slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    infinite: false,
    swipe: false,
    fade: true,
    adaptiveHeight: true,
    speed: 300,
  });
};

export default Timeline;
